module.exports = __webpack_public_path__ + "static/media/back.a36b739e.svg";